import { render, staticRenderFns } from "./ThrillSection.vue?vue&type=template&id=b6d1576c&scoped=true"
import script from "./ThrillSection.vue?vue&type=script&lang=js"
export * from "./ThrillSection.vue?vue&type=script&lang=js"
import style0 from "./ThrillSection.vue?vue&type=style&index=0&id=b6d1576c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d1576c",
  null
  
)

export default component.exports